// React
import { useState, useEffect } from "react";

// Component
import { Tr, Td, TdFixed, TextArea, TextEditor } from "components";
import { Row, Col } from "react-bootstrap";
import { DateConvert } from "utilities";

// Draft JS
import { EditorState, ContentState, convertFromHTML } from "draft-js";

const InfoPeluangSection = ({ data }) => {
  // States
  const [textEditorState, setTextEditorState] = useState(() =>
    EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML("<p></p>")))
  );

  useEffect(
    () =>
      setTextEditorState(
        EditorState.createWithContent(
          ContentState.createFromBlockArray(convertFromHTML(data?.informasi_lainnya ?? "<p></p>"))
        )
      ),
    []
  );

  const List = ({ label, children }) => (
    <Tr>
      <Td>
        <b>{label}</b>
      </Td>
      <TdFixed>:</TdFixed>
      <Td>{children}</Td>
    </Tr>
  );

  return (
    <>
      <Row>
        <Col md>
          <List label="Tgl. Peluang">
            {data?.tgl_peluang ? DateConvert(new Date(data.tgl_peluang)).detail : "-"}
          </List>
          <List label="No. Peluang">{data?.no_peluang ?? "-"}</List>
          <List label="Peringkat Peluang">{data?.nama_peringkat_peluang ?? "-"}</List>
        </Col>

        <Col md>
          <List label="Customer">{data?.nama_customer ?? "-"}</List>
          <List label="ATT">{data?.att ?? "-"}</List>
          <List label="Proyek">{data?.nama_proyek ?? "-"}</List>
        </Col>
      </Row>

      <Row>
        <Col md>
          <TextArea
            label="Keterangan Pengiriman"
            disabled={true}
            value={data?.keterangan_pengiriman}
            rows="4"
          />

          <TextArea
            label="Lokasi Pengiriman"
            disabled={true}
            value={data?.lokasi_pengiriman}
            rows="4"
          />
        </Col>

        <Col md>
          <TextEditor
            readOnly
            label="Informasi Lainnya"
            editorState={textEditorState}
            options={[]}
            editorStyle={{ height: 200 }}
          />
        </Col>
      </Row>

      <hr />
    </>
  );
};

export default InfoPeluangSection;
